export default __webpack_public_path__ + "static/USA-0ee956bad154369166474095b19a3794.png";